<template>
  <div id="municipalities-insee-search">
    <div
      id="municipalitiesSearchInputHelpBlock"
      class="form-text above"
    >
      {{ $t('jurisdictions.municipalities.inseeSearch.help') }}
    </div>
    <Multiselect
      id="municipalitiesSearchInput"
      :value="selectedINSEEs"
      :options="municipalitiesList"
      :options-limit="100"
      :loading="loading"
      :multiple="true"
      :searchable="true"
      :taggable="false"
      :placeholder="$t('jurisdictions.municipalities.inseeSearch.placeholder')"
      track-by="insee"
      label="insee"
      select-label=""
      selected-label=""
      deselect-label=""
      @select="addMunicipality"
      @remove="removeMunicipality"
    >
      <template #selection="{ values, isOpen }">
        <span
          v-if="values.length"
          v-show="!isOpen"
          class="multiselect__single"
        >
          {{ values.length }} {{ $tc('jurisdictions.municipalities.inseeSearch.selection', values.length) }}
        </span>
      </template>
      <span slot="noResult">
        {{ $t('searchbars.noResult') }}
      </span>
      <span slot="noOptions">
        {{ $t('searchbars.noOptions') }}
      </span>
    </Multiselect>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Multiselect from 'vue-multiselect';

export default {
  name: 'MunicipalitiesINSEESearch',

  components: {
    Multiselect,
  },

  props: {
    initValues: {
      type: Array,
      default: () => { return []; }
    }
  },

  data() {
    return {
      loading: false,
      selectedINSEEs: [],
    };
  },

  computed: {
    ...mapState('municipalities', [
      'municipalitiesList',
      'selectedMunicipalities'
    ]),
  },

  watch: {
    initValues: {
      deep: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.selectedINSEEs = newValue.map(el => {
            return {
              insee: el
            };
          });
        }
      }
    },
    selectedMunicipalities: {
      deep: true,
      handler(newValue) {
        this.selectedINSEEs = newValue.map(el => {
          return {
            insee: el.insee
          };
        });
      }
    }
  },

  methods: {
    ...mapActions('municipalities', [
      'SELECT_MUNICIPALITY',
      'DESELECT_MUNICIPALITY'
    ]),
    addMunicipality(e) {
      let value;
      if (e && e.insee) {
        value = e.insee;
      } else {
        value = e;
      }
      if (value && /(.|\s)*\S(.|\s)*/.test(value) && /[a-zA-Z0-9]/.test(value)) {
        const index = this.selectedINSEEs.findIndex(el => el.insee === e.insee);
        if (index === -1) {
          this.selectedINSEEs.push({ insee: value });
        }
        this.SELECT_MUNICIPALITY(e);
      }
    },
    removeMunicipality(e) {
      const index = this.selectedINSEEs.findIndex(el => el.insee === e.insee);
      this.selectedINSEEs.splice(index, 1);
      this.DESELECT_MUNICIPALITY(e);
    }
  }
};
</script>